import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles
import API_URL from './api/config';


function VerifyOtpRegister() {

    const [values, setValues] = useState({ verify_code: '' });
    const navigate = useNavigate();
    axios.defaults.withCredentials = true;


    const [isVerifying, setIsVerifying] = useState(false);

const handleVerifyCode = (e) => {
  e.preventDefault();
  setIsVerifying(true); // disable button

  axios.post(`${API_URL}/register-otp-verify-api`, {
    verify_code: values.verify_code
  })
    .then(res => {
      if (res.data.Status === "Success") {
        localStorage.setItem('verify_code', res.data.verify_code);
        toast.success("Code verified!", { position: "top-right", autoClose: 3000 });
        navigate(res.data.redirect);
      } else {
        toast.error(res.data.Message, { position: "top-right", autoClose: 3000 });
      }
    })
    .catch(() => {
      toast.error("Server error. Please try again.", { position: "top-right", autoClose: 3000 });
    })
    .finally(() => {
      setIsVerifying(false); // re-enable button
    });
};

    /*const handleVerifyCode = (e) => {
        e.preventDefault();
      
        axios.post(`${API_URL}/register-otp-verify-api`, {
            verify_code: values.verify_code
          })
          .then(res => {
            if (res.data.Status === "Success") {
              //Store the code so the next page can use it
              localStorage.setItem('verify_code', res.data.verify_code);
          
              toast.success("Code verified!", { position: "top-right", autoClose: 3000 });

              navigate(res.data.redirect);

            } else {
              toast.error(res.data.Message, { position: "top-right", autoClose: 3000 });
            }
          })
      };*/
      

      
    return (
        <div className="bg_med_green text-white min-vh-100 d-flex align-items-center justify-content-center">
    <ToastContainer />
    <div className="container">
        <div className="row justify-content-center">
            <div className="col-md-6 col-lg-6">

                <div className="bg-med-green text-white p-4 rounded">
                    <div className="card-body text-center">
                        <div className="py-3">
                            <img src="img/logo_1.png" alt="" height="48" />
                        </div>

                    
                            <div className="row g-3">
                            
                            
                                <div className="col-12">
                                    <label>Verify Code</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        onChange={e => setValues({ ...values, verify_code: e.target.value })} 
                                        required 
                                    />
                                </div>
                               
                                
                                <div className="col-12">
                                <button
                                     onClick={handleVerifyCode}
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={isVerifying}
                                    >
                                    {isVerifying ? "Verifying..." : "Verify Code"}
                                    </button>
                                    
                                </div>
                            </div>
                        

                        <p class="text-center text-white" style={{marginTop: '10%'}}>
                        Already have an account?
                            <Link to="/" style={{color: '#184A2C', textDecoration: 'none'}}> Login</Link>
                        </p>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

    );
}

export default VerifyOtpRegister;
